import { Button } from "@facade/components/ui";
import { CircleAlert, RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";

export function RouteErrorPage() {
  const { t } = useTranslation();

  return (
    <main className="bg-background text-foreground flex min-h-svh items-center justify-center p-6">
      <section className="flex max-w-md flex-col items-center gap-4 text-center">
        <span className="bg-destructive/10 text-destructive flex size-12 items-center justify-center rounded-full">
          <CircleAlert className="size-6" />
        </span>

        <div className="space-y-1">
          <h1 className="text-xl font-semibold">{t("app.error.title")}</h1>
          <p className="text-muted-foreground text-sm">
            {t("app.error.description")}
          </p>
        </div>

        <Button onClick={() => window.location.reload()}>
          <RefreshCw />
          {t("app.error.reload")}
        </Button>
      </section>
    </main>
  );
}
